import { HStack, Image, Text, VStack } from "@chakra-ui/react";
import { interpretBoldTags } from "../../../utils/processPaywallText";
import { GradientDivider } from "./GradientDivider";
import { ValuePropType } from "../types";

export function RedesignedValueProps({
  valueProps,
}: {
  valueProps: ValuePropType[];
}) {
  return (
    <VStack gap={5} px={6} width="100%">
      <GradientDivider />
      {valueProps.map((vp, i) => (
        <RedesignedValueProp key={i} valueProp={vp} />
      ))}
    </VStack>
  );
}

function RedesignedValueProp({ valueProp }: { valueProp: ValuePropType }) {
  const bodyHtml = interpretBoldTags(valueProp.body, 600, "inherit", "white");
  return (
    <HStack gap={5} alignItems="start" width="100%">
      <Image src={valueProp.icon_url} boxSize="48px" flexShrink={0} />
      <VStack alignItems="start" gap={1}>
        <Text
          fontWeight={700}
          fontSize="16px"
          lineHeight="1.5"
          color="white"
        >
          {valueProp.header}
        </Text>
        <Text
          fontSize="14px"
          lineHeight="1.6"
          color="neutral.400"
          dangerouslySetInnerHTML={{ __html: bodyHtml }}
        />
      </VStack>
    </HStack>
  );
}
